import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_COMPLAINTS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import dayjs from "dayjs";

export function useComplaints(maxDaysAgo = 30, customDateRange = null) {
  const { data, error } = useSWRSubscription(
    `complaints-${maxDaysAgo}-${customDateRange ? `${customDateRange[0]}-${customDateRange[1]}` : "null"}`,
    (key, { next }) => {
      try {
        // Determine date range for filtering
        let startTimestamp, endTimestamp;

        if (customDateRange && customDateRange[0] && customDateRange[1]) {
          // Use custom date range - convert to unix timestamps
          startTimestamp = dayjs(customDateRange[0]).startOf("day").unix();
          endTimestamp = dayjs(customDateRange[1]).endOf("day").unix();
        } else {
          // Use maxDaysAgo
          startTimestamp = dayjs().subtract(maxDaysAgo, "days").startOf("day").unix();
          endTimestamp = dayjs().add(30, "days").endOf("day").unix();
        }

        // Build Firestore query with date filtering on createdAt
        const complaintsQuery = query(
          collection(firestore, `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_COMPLAINTS_TABLE}`),
          where("createdAt", ">=", startTimestamp),
          where("createdAt", "<=", endTimestamp),
        );

        // Listen to complaints with real-time updates
        const unsubscribeComplaints = onSnapshot(
          complaintsQuery,
          (snapshot) => {
            try {
              const complaints = snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
              }));
              next(null, complaints);
            } catch (err) {
              console.error("Error processing snapshot:", err);
              next(err, null);
            }
          },
          (error) => {
            console.error("Firestore onSnapshot error:", error);
            next(error, null);
          },
        );

        // Return cleanup function
        return () => {
          unsubscribeComplaints();
        };
      } catch (error) {
        console.error("Error in useComplaints setup:", error);
        next(error, null);
      }
    },
  );

  return {
    data,
    error,
    loading: !data && !error,
  };
}
